import type { IHistoryItem, IHistoryItemData } from "../types/history.types";
import uuid4 from "../utils/uuid4";

export default class HistoryItemModel implements IHistoryItem {
  id: string = uuid4();
  prev: IHistoryItem['id'] | null = null;

  constructor(
    public data: IHistoryItemData,    
  ) { };
}